import { render, staticRenderFns } from "./salesTablebj.vue?vue&type=template&id=3bdc12cd"
import script from "./salesTablebj.vue?vue&type=script&lang=js"
export * from "./salesTablebj.vue?vue&type=script&lang=js"
import style0 from "./salesTablebj.vue?vue&type=style&index=0&id=3bdc12cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports